import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import 'antd-mobile/dist/antd-mobile.css';
import AppRoute from './router'
import * as serviceWorker from './serviceWorker';
import './i18n';

ReactDOM.render(AppRoute, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
